import { Vector3 } from 'three';

/**
 * Extracts contours for a given edges.
 *
 * @example
 * ```ts
 * const edges = computeEdges(positions, indexes);
 * const contours = computeContours(edges);
 */
export const computeContours = (edges: [Vector3, Vector3][]) => {
  const graph = new Map<string, Vector3[]>();

  edges.forEach(([start, end]) => {
    const startKey = `${start.x},${start.y},${start.z}`;
    const endKey = `${end.x},${end.y},${end.z}`;

    if (!graph.has(startKey)) graph.set(startKey, []);
    if (!graph.has(endKey)) graph.set(endKey, []);

    graph.get(startKey)!.push(end);
    graph.get(endKey)!.push(start);
  });

  const visited = new Set<string>();
  const contours: Vector3[][] = [];

  for (const [start] of edges) {
    const startKey = `${start.x},${start.y},${start.z}`;
    if (visited.has(startKey)) continue;

    const contour: Vector3[] = [];
    const stack = [start];

    while (stack.length > 0) {
      const node = stack.pop()!;
      const nodeKey = `${node.x},${node.y},${node.z}`;

      if (!visited.has(nodeKey)) {
        visited.add(nodeKey);
        contour.push(node);
        const neighbors = graph.get(nodeKey)!;
        for (const neighbor of neighbors) {
          const neighborKey = `${neighbor.x},${neighbor.y},${neighbor.z}`;
          if (!visited.has(neighborKey)) {
            stack.push(neighbor);
          }
        }
      }
    }

    if (contour.length > 0) {
      contours.push(contour);
    }
  }

  return contours;
};
